import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BaseService } from '../base.service'

@Injectable({
  providedIn: 'root'
})
export class ClubService extends BaseService {
  contextPath = this.path + '/clubs'

  search(params: any): Observable<any> {
    return this.get(this.contextPath, params)
  }

  create(payload: any): Observable<any> {
    return this.post(this.contextPath + '', payload)
  }

  update(payload: any): Observable<any> {
    return this.put(this.contextPath + `/${payload?.id}`, payload)
  }

  deleteItem(id: any): Observable<any> {
    return this.delete(this.contextPath + `/${id}`)
  }

  getDetail(id: number): Observable<any> {
    return this.get(this.contextPath + `/${id}`, null)
  }
}
